import { SearchBar } from "./SearchBar";
import { PopoverSearch } from "./PopoverSearch";

const Search = { Bar: SearchBar, Popover: PopoverSearch };

export * from "./useSearch";
export * from "./types.d";
export default Search;
